import { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import "./custom.css";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import "tw-elements";
import "react-toastify/dist/ReactToastify.css";
import toast, { Toaster } from "react-hot-toast";
import { CustomToastProvider, useCustomToast } from "./components/customtoast/CustomToastProvider";
import ChatwootWidget from "./components/ChatwootWidget/ChatwootWidget";
import CandidateRoutes_ from "./pages/candidate/CandidateRoutes";
import ErrorBoundary from "../src/components/errorBoundary/errorBoundary";
import { UserContext } from "./context/index.js";
// import SignPage from "./pages/account/Signin";
import RegisterPage from "./pages/account/register";
import LoginPage from "./pages/account/login";
import VerifyRegisteredUserEmail from "./pages/account/verifyUserEmail";
import VerificationStatus from "./pages/account/VerificationStatus";
//import ResetPassword from "./pages/account/resetPasswordOld.jsx";
import ForgotPassword from "./pages/account/forgotPassword";
import NotFound from "./notFound";
import NotFoundPage from "./components/404Page/NotFoundPage.jsx";
import RegisterExamPage from "./pages/StandaloneExam/RegisterExamPage";
import RejoinTestPage from "./pages/StandaloneExam/RejoinTestPage";
import EmailVerification from "./pages/account/EmailVerification";
import Verification from "./pages/account/Verification.jsx";
import ResetPassword from "./pages/account/updatePassword.jsx";
import ReleaseNotes from "./pages/ReleaseNotes/ReleaseNotes.jsx";
import Redirect from "./pages/candidate/redirect/Redirect.jsx";
import StartExam from "./pages/StandaloneExam/StartExam.jsx";
import OnboardExam from "./pages/StandaloneExam/OnboardExam.jsx";
import JointExam from "./pages/joinExam/JointExam";
import JointExamLaunch from "./pages/joinExamLaunch/JointExam";
import ChatbotWidget from "./components/ChatbotWidget/ChatbotWidget";
import TranslationLoader from "./components/TranslationLoader";
import SupportWidget from "./components/SupportWidget/SupportWidget";
import ViewResult from "./pages/candidate/view-result/ViewResult";
import ViewBooking from "./pages/booking/viewBooking";
import ProctorTest from "./pages/ProctorTest/ProctorTest";

const queryClient = new QueryClient();

function App() {

  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const location = useLocation();
  const currentRoute = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const campaignId = queryParams.get("camapign_id");

  const [isOpen, setIsOpen] = useState(true);
  const customToast = useCustomToast();
  const toggleChat = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      const user = JSON.parse(userData);
      setUser((x) => ({ ...x, profile: user }));
    } else if (!userData && currentRoute.includes("/candidate")) {
      if (campaignId !== null)
        sessionStorage.setItem("profile-campaign-id", campaignId);
      navigate("/");
      toast.remove();
      toast("Login to your account");
    }
  }, []);

  useEffect(
    () => {
      window.localStorage.openpages = Date.now();
      window.addEventListener('storage', (e) => {
        if (e.key === 'openpages') {
          window.localStorage.page_available = Date.now()
        }
        if (e.key === 'page_available') {
          customToast.error('You had open multiple tabs, please close all duplicate tabs');
          setTimeout(() => {
            window.location.href = 'about:blank';
          }, 4000);
        }
      }, false)
    },
    [location.pathname]
  );

  const disabled = process.env.REACT_APP_DISABLE_ROUTE;

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <UserContext.Provider value={{ user, setUser }}>
          <Routes>
            {/* <Route path="/" element={<SignPage />} /> */}
            {/*}  <Route
                path="/register"
                element={
                  disabled === "disable-route" ? <NotFound /> : <RegisterPage />
                } 
              /> */}
            <Route
              path="/auth/forgot-password"
              element={<TranslationLoader><ForgotPassword /></TranslationLoader>}
            />
            <Route
              path="/reset-password"
              element={
                disabled === "disable-route" ? (
                  <NotFound />
                ) : (
                  <TranslationLoader><ResetPassword /></TranslationLoader>
                )
              }
            />
            <Route
              path="/email-verification"
              element={
                disabled === "disable-route" ? (
                  <NotFound />
                ) : (
                  <TranslationLoader><EmailVerification /></TranslationLoader>
                )
              }
            />
            <Route
              path="/verification"
              element={
                disabled === "disable-route" ? <NotFound /> : <Verification />
              }
            />
            <Route
              path="/VerificationStatus"
              element={
                <TranslationLoader><VerificationStatus /></TranslationLoader>

              }
            />
            <Route
              path="/booking/:id"
              element={
                <TranslationLoader><ViewBooking /></TranslationLoader>

              }
            />
            <Route
              path="/email/verify/:id1/:id2"
              element={<VerifyRegisteredUserEmail />}
            />
            <Route
              path="/application/:slug"
              element={
                disabled === "disable-route" ? <NotFound /> : <RegisterPage />
              }
            />
            <Route
              path="/application/:slug/:referral"
              element={
                disabled === "disable-route" ? <NotFound /> : <RegisterPage />
              }
            />
            <Route path="/candidate/*" element={<CandidateRoutes_ />} />
            <Route path="/joint-exam/:id" element={<TranslationLoader><JointExam /></TranslationLoader>} />
            <Route path="/exams/:id/launch" element={<TranslationLoader><JointExamLaunch /></TranslationLoader>} />
            <Route path="/start-exam/participants/initiate-assessment" element={<Redirect />} />
            <Route path="*" element={<NotFoundPage url={"/"} />} />
            <Route path="/" element={
              <TranslationLoader>
                <LoginPage />
              </TranslationLoader>
            } />
            <Route path="/exam/:slug" element={<RegisterExamPage />} />
            <Route path="/LR_release_note" element={<ReleaseNotes />} />
            <Route path="/proctor-test" element={<ProctorTest />} />
            <Route path="/rejoin-exam" element={<RejoinTestPage />} />
            <Route path="/start-exam" element={<StartExam />} />
            <Route path="/onboard-exam" element={<OnboardExam />} />
            <Route path="/exam-result" element={
              <TranslationLoader>
                <ViewResult />
              </TranslationLoader>
            } />
          </Routes>
        </UserContext.Provider>

        {!currentRoute.includes("candidate-assessment") && (
          <>
            <ChatwootWidget />
            <ChatbotWidget src="https://bot.serviceschoolhouse.com/99472f4d-bf99-4804-8455-36a515979678/chatbot" />
          </>
        )}
        {/*<ReactQueryDevtools initialIsOpen={false} position="bottom-left" />*/}

      </QueryClientProvider>
      <Toaster
        toastOptions={{
          // style: {
          //   color: "#023047",
          // },
          success: {
            iconTheme: {
              primary: "#90EE90",
            },

            style: {
              color: "#023047",
            },
            duration: 6000,
          },
          error: {
            duration: 5000,
          },
        }}
      />
    </ErrorBoundary>
  );
}

export default App;
